"use client";

import { applyBrandFaviconLink } from "@/lib/brand-favicon";
import { useTheme } from "next-themes";
import { useEffect } from "react";

/** Keeps tab favicon aligned with app theme (`class="dark"`), not only OS preference. */
export function BrandFaviconSync(): null {
  const { resolvedTheme } = useTheme();

  useEffect((): void => {
    if (resolvedTheme == null) return;
    applyBrandFaviconLink(resolvedTheme === "dark");
  }, [resolvedTheme]);

  return null;
}
